package com.flowyride.core.domain.model

import kotlin.jvm.JvmInline

/** Opaque identifier of a routing engine implementation (e.g. "tomtom"). */
@JvmInline
value class RouteEngineId(val value: String)
